import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const TicketCountChart = ({ data, name }) => {
  const chartData = {
    labels: data.map(item =>
      name === 'hourChart' ? item.time_period :
      name === 'monthChart' ? item.year_month :
      ''
    ),
    datasets: [
      {
        label: 'Ticket Counts',
        data: data.map(item => item.ticket_count),
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: name === 'hourChart'
          ? 'Ticket Counts for the Hour Periods'
          : name === 'monthChart'
          ? 'Ticket Counts for the Last 6 Months'
          : '',
      },
      datalabels: {
        color: '#183039',
        align: 'top',
        font: {
          weight: 'bold',
        },
        formatter: (value) => value,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          autoSkip: true,
          maxTicksLimit: 5,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="overflow-x-auto max-w-full">
  <div className="min-w-[300px] w-full">
    <Bar data={chartData} options={options} />
  </div>
</div>
  );
  
};

export default TicketCountChart;
